import axiosInstance from "../../translator";
import { dashboardApi } from "../../constants/apis/apiEndpoints";

export const getDashboardResourceProviderListRequest = async (urlParams) => {
  const resList = await axiosInstance
    .get(`${dashboardApi?.resourceProviderList}${urlParams}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
  return resList;
};

export const getDashboardResourcesStatsRequest = async (urlParams) => {
  const resStats = await axiosInstance
    .get(`${dashboardApi?.resourcesInfo}${urlParams}`)
    .then((response) => response)
    .catch((error) => error);
  return resStats;
};

export const getDashboardTenantStatsRequest = async (urlParams) => {
  const tenStats = await axiosInstance
    .get(`${dashboardApi?.tenantStats}${urlParams}`)
    .then((response) => response)
    .catch((error) => error);
  return tenStats;
};

export const getDashboardUserStatsRequest = async (urlParams) => {
  const userStats = await axiosInstance
    .get(`${dashboardApi?.userStats}${urlParams}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
  return userStats;
};

export const getDashboardUserDropDownRequest = async (urlParams) => {
  const userList = await axiosInstance
    .get(`${dashboardApi?.usersDropDown}${urlParams}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
  return userList;
};

export const getDashboardPendingActionsRequest = async () => {
  const pendingCount = await axiosInstance
    .get(`${dashboardApi?.pendingActCount}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
  return pendingCount;
};

export const getDashboardVmStatsRequest = async (urlParams) => {
  const vmStats = await axiosInstance
    .get(`${dashboardApi?.vmStats}${urlParams}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
  return vmStats;
};

export const getDashboardTenantUserVMStatsRequest = async () => {
  const vmStats = await axiosInstance
    .get(`${dashboardApi?.vmStatsTenantUser}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
  return vmStats;
};

export const getDashboardBillingStatsRequest = async ({ urlParams, reqBody }) => {
  const billStats = await axiosInstance
    .post(`${dashboardApi?.billingInfo}${urlParams}`, reqBody)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
  return billStats;
};

export const getDashALLVMList = async (urlParams) => {
  const allVMs = await axiosInstance
    .get(`${dashboardApi?.VMDetails}${urlParams}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
  return allVMs;
};

export const getDashTrendingLabsRequest = async (urlParams) => {
  const trendingLabs = await axiosInstance
    .get(`${dashboardApi?.trendingLabs}${urlParams}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
  return trendingLabs;
};

export const getDashboardUsageHoursRequest = async ({ urlParams }) => {
  const usageHours = await axiosInstance
    .get(`${dashboardApi?.usageHours}${urlParams}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
  return usageHours;
};

export const getDashboardForecastBillingRequest = async ({ urlParams }) => {
  const forecast = await axiosInstance
    .get(`${dashboardApi?.billingForecast}${urlParams}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
  return forecast;
};
export const getDashboardCSMUsageTrends = async ({ urlParams, reqBody }) => {
  const billStats = await axiosInstance
    .post(`${dashboardApi?.usage}${urlParams}`, reqBody)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
  return billStats;
};

export const resourceProviderCountApi = async (params) => {
  return axiosInstance
    .get(`${dashboardApi?.resourceProviderCount}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};